// Plain-English summaries of steps, shown on trail cards and viewers.
import { getStepDefinition } from "./registry";

const DESCRIBERS = {
  code: (p) => p.summary || "Code written by Ledgerate AI",
};

export const describeStep = (step) => {
  const describe = DESCRIBERS[step.type];
  if (describe) {
    try {
      return describe(step.params || {});
    } catch {
      // fall through to the generic label
    }
  }
  return getStepDefinition(step.type)?.description || step.type;
};
